import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import usePageMeta from "@/lib/usePageMeta";
import SectionHead from "@/components/SectionHead";
import { Reveal } from "@/components/Reveal";
import { SERVICES, PROCESS_STEPS } from "@/lib/data";
import ProcessSection from "@/components/home/ProcessSection";

export default function Services() {
  usePageMeta(
    "Recruitment Services | IT, Non-IT, Leadership & Volume Hiring — Talentify",
    "Explore Talentify's recruitment solutions: IT recruitment, Non-IT recruitment, leadership hiring, volume hiring and end-to-end recruitment support across PAN India."
  );
  return (
    <main>
      <section className="relative overflow-hidden pb-10 pt-40">
        <div className="pointer-events-none absolute inset-0" style={{ background: "radial-gradient(circle at 50% -20%, rgba(99,102,241,0.12), transparent 60%)" }} />
        <div className="relative mx-auto max-w-7xl px-6">
          <SectionHead
            overline="Our Services"
            title="Our Recruitment Solutions"
            sub="Five specialised practices covering technology, corporate functions, leadership and scale — delivered with one quality standard."
            testid="services-page-heading"
          />
        </div>
      </section>

      <section className="pb-10">
        <div className="mx-auto max-w-7xl space-y-6 px-6">
          {SERVICES.map((s, i) => (
            <Reveal key={s.id} delay={0.05}>
              <div
                data-testid={`services-detail-${s.id}`}
                className="group grid grid-cols-1 gap-8 rounded-3xl border border-white/[0.08] bg-[#0A0F1D]/70 p-9 transition-[border-color] duration-500 hover:border-sky-400/25 sm:p-12 lg:grid-cols-[auto_1fr_auto]"
              >
                <div className="flex items-start gap-6">
                  <span className="font-display text-5xl font-extrabold tracking-tight text-white/[0.08] transition-colors duration-500 group-hover:text-sky-400/25">{s.num}</span>
                  <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl border border-white/[0.08] bg-white/[0.03] text-sky-400">
                    <s.icon size={22} />
                  </span>
                </div>
                <div>
                  <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-sky-400/80">{s.tag}</p>
                  <h3 className="mt-2 font-display text-2xl font-bold tracking-tight text-white">{s.title}</h3>
                  <p className="mt-3 max-w-2xl text-sm leading-relaxed text-slate-400">{s.desc}</p>
                  {s.items && (
                    <div className="mt-5 flex flex-wrap gap-2">
                      {s.items.map((it) => (
                        <span key={it} className="rounded-full border border-white/[0.07] bg-white/[0.03] px-3 py-1 text-[11px] text-slate-400">{it}</span>
                      ))}
                    </div>
                  )}
                  {s.flow && (
                    <div className="mt-5 flex flex-wrap items-center gap-x-1.5 gap-y-2">
                      {s.flow.map((f, fi) => (
                        <span key={f} className="flex items-center gap-1.5 text-[11px] text-slate-400">
                          <span className="rounded-full border border-sky-400/20 bg-sky-400/[0.06] px-3 py-1 text-sky-300">{f}</span>
                          {fi < s.flow.length - 1 && <ArrowRight size={10} className="text-slate-600" />}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
                <div className="flex items-end lg:justify-end">
                  <Link
                    to="/employers"
                    data-testid={`services-enquire-${s.id}`}
                    className="group/btn inline-flex items-center gap-2 rounded-full border border-white/15 px-6 py-3 text-sm font-semibold text-slate-200 transition-[border-color,background-color] duration-300 hover:border-sky-400/50 hover:bg-sky-400/5"
                  >
                    Enquire <ArrowRight size={15} className="transition-transform duration-300 group-hover/btn:translate-x-1" />
                  </Link>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <ProcessSection />
    </main>
  );
}
